export const routes = [
  ...require('./home/routes').routes,
  ...require('./dasboard/routes').routes,
  ...require('./template/routes').routes,
  ...require('./campaign/routes').routes
]
